import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import {
  apiBaseUrl,
  prepareAuthHeaders,
  storefrontCompanySlug,
} from "./apiBase";

export const storefrontApi = createApi({
  reducerPath: "storefrontApi",
  baseQuery: fetchBaseQuery({
    baseUrl: apiBaseUrl,
    prepareHeaders: (headers) => prepareAuthHeaders(headers, { acceptJson: true }),
  }),
  tagTypes: ["StorefrontProducts", "StorefrontProduct"],
  keepUnusedDataFor: 60,

  endpoints: (builder) => ({
    fetchStorefrontProducts: builder.query({
      query: (params = {}) => ({
        url: "storefront/products",
        params: {
          companySlug: params.companySlug || storefrontCompanySlug,
          ...params,
        },
      }),
      transformResponse: (res) => res?.data?.products ?? [],
      providesTags: (result) =>
        result?.length
          ? [
              ...result.map((product) => ({
                type: "StorefrontProduct",
                id: product.id,
              })),
              { type: "StorefrontProducts", id: "LIST" },
            ]
          : [{ type: "StorefrontProducts", id: "LIST" }],
    }),
    fetchStorefrontProductBySlug: builder.query({
      query: ({ slug, companySlug = storefrontCompanySlug }) => ({
        url: `storefront/products/${slug}`,
        params: { companySlug },
      }),
      transformResponse: (res) => res?.data ?? null,
      providesTags: (_result, _error, arg) => [
        { type: "StorefrontProduct", id: arg.slug },
      ],
    }),
  }),
});

export const {
  useFetchStorefrontProductsQuery,
  useFetchStorefrontProductBySlugQuery,
} = storefrontApi;
